import React from 'react';
import IconName from "../../svgLogo/SvgLogo";

const AddCommentBox = () => {
    return (
        <div className="add-comment-content">
            <div className="container">
                <div className="title-product xmb-lg-8 d-flex align-items-center">
                    <div className="img xp-1 xp-lg-2 xml-4">
                        <img src="./assets/sample-image/1420-w320h320.png" alt="img" className="img-fluid"/>
                    </div>
                    <div className="title-box">
                        <h2 className="title">
                            گوشی شیائومی می نوت ۹ پرو دوسیم کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ رم
                        </h2>
                    </div>
                </div>

                <div className="inputs-text-comment">
                    <div className="row">
                        <div className="col-lg-6 order-1">
                            <div className="info-comment position-relative">
                                <input type="text" placeholder="نقاط قوت"
                                       className="form-control input-normal-comment xmt-4"/>
                                <IconName name="add" className="icon add-icon position-absolute"/>
                            </div>
                        </div>
                        <div className="col-lg-6 order-3 order-lg-2">
                            <div className="info-comment position-relative">
                                <input type="text" placeholder="نقاط ضعف"
                                       className="form-control input-normal-comment xmt-4"/>
                                <IconName name="add" className="icon add-icon position-absolute"/>
                            </div>
                        </div>
                        <div className="col-lg-6 order-2 order-lg-3">
                            <div className="positive-product position-relative xmt-4">
                                <div className="box"><span className="text">شارژ دهی خوب باتری</span>
                                    <IconName name="expand_close" className="icon close-icon position-absolute"/>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 order-4">
                            <div className="negative-product position-relative xmt-4">
                                <div className="box"><span className="text">کیفیت پایین صفحه نمایش</span>
                                    <IconName name="expand_close" className="icon close-icon position-absolute"/>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 order-5">
                            <textarea placeholder="متن نظر شما (اجباری)" className="xmt-4 text-comment"/>
                        </div>
                    </div>
                </div>

                <div className="product-recommendation xmt-4 xmt-lg-12">
                    <div className="title xmb-2 xmb-lg-4">آیا خرید این محصول را به دوستانتان پیشنهاد می کنید؟</div>
                    <ul className="nav">
                        <li className="nav-item form-check xmt-2">
                            <label className="form-check-label">
                                <input className="form-check-input" type="radio" name="suggest"/>
                                پیشنهاد می کنم
                            </label>
                        </li>
                        <li className="nav-item form-check xmt-2">
                            <label className="form-check-label">
                                <input className="form-check-input" type="radio" name="suggest"/>
                                خیر ، پیشنهاد نمی‌کنم
                            </label>
                        </li>
                        <li className="nav-item form-check xmt-2">
                            <label className="form-check-label">
                                <input className="form-check-input" type="radio" name="suggest"/>
                                نظری ندارم
                            </label>
                        </li>
                    </ul>
                </div>

                <div
                    className="product-score xmt-8 d-block d-lg-flex justify-content-between align-items-center">
                    <div className="score d-block d-lg-flex align-items-center">
                        <span className="text">چه امتیازی به این محصول می‌دهید؟</span>
                        <span className="gl-star-rating">
 <select style={{display: "none"}} className="star-rating" data-options='{"clearable":false}'>
    <option value="">Select a rating</option>
    <option value="5">5 Stars</option>
    <option value="4">4 Stars</option>
    <option value="3">3 Stars</option>
    <option value="2">2 Stars</option>
    <option value="1">1 Star</option>
  </select>
  <span className="gl-star-rating--stars" data-rating="1">
    <span data-value="1"></span>
    <span data-value="2"></span>
    <span data-value="3"></span>
    <span data-value="4"></span>
    <span data-value="5"></span>
  </span>
</span>
                    </div>
                    <div className="submit-comment xmt-6 xmt-lg-0">
                        <span className="button" id="submit-comment-btn">ثبت نظر</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddCommentBox;
